import { ComponentRoute } from '@/classes'

const UnscheduledModelRoutes = {
  UnscheduledModelListView: new ComponentRoute('/unscheduledmodels', 'UnscheduledModelListView'),
  UnscheduledModelView: new ComponentRoute('/unscheduledmodels/:modelCustomId', 'UnscheduledModelView'),
  UnscheduledModelDetail: new ComponentRoute('/unscheduledmodels/:modelCustomId', 'UnscheduledModelDetail')
}

export default UnscheduledModelRoutes
